import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

export default function CTABanner() {
  return (
    <section className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Bento Grid Layout */}
        <div className="grid lg:grid-cols-2 gap-6">
          {/* Main CTA Card */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.2 }}
            className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 lg:p-12"
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 mb-6">
              <span className="text-sm text-white font-medium">Get Started</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-light text-white mb-6 leading-tight">
              Ready to Fix Your
              <span className="block font-bold">Drainage Issues?</span>
            </h2>
            <p className="text-slate-300 text-lg mb-8 leading-relaxed">
              Professional drainage solutions from certified experts. Get a free quote today and experience the  Total Repair UK difference.
            </p>
            <button className="bg-white text-slate-900 hover:bg-slate-100 px-8 py-6 rounded-2xl font-semibold text-lg group transition-all hover:scale-105">
              Request Free Quote
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </motion.div>

          {/* Contact Cards */}
          <div className="grid gap-6">
            {/* Phone Card */}
            <motion.a
              href="tel:+12342312123"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.05, duration: 0.2 }}
              whileHover={{ scale: 1.01 }}
              className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all group"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 rounded-2xl bg-slate-100 flex items-center justify-center">
                  <Phone className="w-7 h-7 text-slate-900" />
                </div>
                <div>
                  <div className="text-slate-600 text-sm font-medium uppercase tracking-wide">Call Us 24/7</div>
                  <div className="text-3xl font-bold text-slate-900">(234) 231-2123</div>
                </div>
              </div>
              <div className="text-slate-600 text-sm">Emergency service available around the clock</div>
            </motion.a>

            {/* Info Card */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1, duration: 0.2 }}
              className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8"
            >
              <div className="grid grid-cols-2 gap-6 text-center">
                <div>
                  <div className="text-3xl font-bold text-white mb-2">Mon-Sun</div>
                  <div className="text-slate-400 text-sm">8:00 AM - 8:00 PM</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-white mb-2">Same Day</div>
                  <div className="text-slate-400 text-sm">Service Available</div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}